import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSpring } from 'react-spring';
import If from 'components/if-statement';
import SurfacesList from 'components/canvas/components/top-left-menu/components/breadcrumbs/components/surfaces-list';
import ShareSurfaceButton from 'components/canvas/components/top-left-menu/components/share-surface-button';
import {
  ArrowIcon,
  BreadcrumbContainer,
  BackButton,
  CurrentSurfaceName,
  Separator,
  Tail,
  Surface,
  DropdownMenu,
  Decoration,
} from './style';
import { Column, Row } from 'components/layout';
import { isMobile, isDesktop } from 'react-device-detect';

interface BreadcrumbsProps {
  surfaceHierarchy: any[];
}

function truncateTail(list: any[], limit: number) {
  return list.slice(-limit);
}

function truncateHead(list: any[], limit: number) {
  return list.slice(0, list.length - limit);
}

function Breadcrumbs({ surfaceHierarchy = [] }: BreadcrumbsProps) {
  const history = useHistory();
  const [showDropdown, setShowDropdown] = React.useState<boolean>(false);

  const DISPLAY_LIMIT = isMobile ? 0 : 2;

  const [opacity, setOpacity] = React.useState(0);

  React.useEffect(() => {
    setOpacity(1);
  }, []);

  const loadingAnimation = useSpring({
    from: { opacity: 0 },
    to: { opacity /*: isLoading ? 0 : 1*/ },
  });

  const surfacesHash = surfaceHierarchy.map(({ value }) => value).join('.');

  const currentSurface = [...surfaceHierarchy].pop();

  const dropdownSurfaces = React.useMemo<any>(
    () => truncateHead(surfaceHierarchy, DISPLAY_LIMIT),
    [surfacesHash],
  );

  const breadcrumbSurfaces = React.useMemo<any>(
    () => truncateTail(surfaceHierarchy, DISPLAY_LIMIT),
    [surfacesHash],
  );

  function hideDropdown() {
    setShowDropdown(false);
  }

  function toggleDropdown() {
    setShowDropdown(!showDropdown);
  }

  function goBackInHistory() {
    history.goBack();
  }

  return (
    <Column>
      <BreadcrumbContainer style={loadingAnimation}>
        <Row alignCenter>
          <BackButton onClick={goBackInHistory} />
          <Separator />
          <Tail>
            {surfaceHierarchy.length > DISPLAY_LIMIT && (
              <Surface onClick={toggleDropdown}>
                <If condition={isDesktop}>
                  <If.Then>
                    <>...</>
                  </If.Then>
                  <If.Else>
                    <CurrentSurfaceName>
                      {currentSurface.name}
                    </CurrentSurfaceName>
                    &nbsp;
                    <ArrowIcon $showDropdown={showDropdown} />
                  </If.Else>
                </If>
              </Surface>
            )}
            <If condition={isDesktop}>
              <SurfacesList
                surfaces={breadcrumbSurfaces}
                onSurfaceSelect={hideDropdown}
              />
            </If>
          </Tail>
          <ShareSurfaceButton surface={currentSurface} />
        </Row>
      </BreadcrumbContainer>
      {showDropdown && (
        <DropdownMenu>
          <Decoration />
          <SurfacesList
            surfaces={dropdownSurfaces}
            onSurfaceSelect={hideDropdown}
          />
        </DropdownMenu>
      )}
    </Column>
  );
}

export default Breadcrumbs;
